import type {ReactElement} from 'react';
import React from 'react';
import styles from './cursor-overlay.module.scss';
import {useAppSelector} from '@/hooks';
import {CURSOR_OVERLAY_CONTAINER_ID} from '@Components/poster-editor/components/cursor-overlay/cursor-overlay.types';

export function CursorOverlay(): ReactElement<any> {
  const isPickingModeEnabled = useAppSelector((state) => {
    return state.posterEditor.isPickingModeEnabled;
  });
  const isRemoveBGModeEnabled = useAppSelector((state) => {
    return state.posterEditor.isRemoveBGModeEnabled;
  });
  const areStylesCopied = useAppSelector((state) => {
    return state.posterEditor.copiedStyles;
  });

  const getClassName = (): string => {
    if (areStylesCopied) {
      return styles.pasteStyleCursor;
    }
    if (isPickingModeEnabled) {
      return styles.colorPickerCursor;
    }
    if (isRemoveBGModeEnabled) {
      return styles.removeBGCursor;
    }
    return styles.displayNone;
  }

  return (
    <div
      id={CURSOR_OVERLAY_CONTAINER_ID}
      className={`${styles.container} ${getClassName()}`}
    />
  );
}
